/** 判断队列值是否为可安全递归复制的普通对象。 */
function isPlainObject(value: object): value is Record<string, unknown> {
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

/**
 * 复制埋点队列中的 JSON/普通对象值，避免调用方在 flush 前修改原对象。
 * 非普通宿主对象保持原引用，避免改变既有 SDK 参数语义。
 */
export function cloneTrackingValue<T>(
  value: T,
  seen: WeakMap<object, unknown> = new WeakMap<object, unknown>(),
): T {
  if (value === null || typeof value !== 'object') {
    return value;
  }

  const existingClone = seen.get(value);
  if (existingClone) {
    return existingClone as T;
  }

  if (value instanceof Date) {
    return new Date(value.getTime()) as T;
  }

  if (Array.isArray(value)) {
    const clonedArray: unknown[] = [];
    seen.set(value, clonedArray);
    value.forEach((item) => clonedArray.push(cloneTrackingValue(item, seen)));
    return clonedArray as T;
  }

  if (!isPlainObject(value)) {
    return value;
  }

  const clonedObject: Record<string, unknown> = {};
  seen.set(value, clonedObject);
  Object.entries(value).forEach(([key, item]) => {
    clonedObject[key] = cloneTrackingValue(item, seen);
  });
  return clonedObject as T;
}
